import * as Sentry from '@sentry/nuxt';

Sentry.init({
  dsn: 'https://3cb3e22a8c7106f3e1075cfdad5dd8db@o4508329968009216.ingest.us.sentry.io/4508330447405056',
  tracesSampleRate: 1.0,
});